import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';

@Component({
  selector: 'app-packing-list',
  templateUrl: './packing-list.component.html',
  styleUrls: ['./packing-list.component.scss']
})
export class PackingListComponent implements OnInit {
  PackListForm: FormGroup;
  filteredDataList: any;
  DataList: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  listdesc: any;
  clgname: any;
  SessionNo: any;
  Table = false;
  List: any;
  packingList: any;
  PackingArray: FormArray;
  assignTableData: any;
  Packing: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder, private location: Location,
  ) { }

  ngOnInit(): void {
    this.List = '';
    this.Table = false;
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getExmFrmList(this.SessionNo);
    }
    this.PackListForm = this.fb.group({
      // PcklistNo: new FormControl(''),
      PcklistNo2: new FormControl(),
      PcklistNo3: new FormControl(''),
      Valid: new FormControl(),
      Chng: new FormControl(),
      SubCode: new FormControl(),
      HdCode: new FormControl(),
      Medium: new FormControl(),
      Bran: new FormControl(),
      EcId: new FormControl('',Validators.required),
      // PcSub: new FormControl(),
      // Cent: new FormControl(),
      // P1: new FormControl(),
      // P2: new FormControl(),
      // P3: new FormControl(),
      // P4: new FormControl(),
      // P5: new FormControl(),
      // P6: new FormControl(),
      // P7: new FormControl(),
      // EsId: new FormControl(),
      // Count: new FormControl(),
      // Total: new FormControl(),
      PackingArray: new FormArray([]),
     } );
    //  this.ControlLock();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.getExmFrmList(this.SessionNo);
      }
    );
  }

  getExmFrmList(SnNo){
    const payload = {};
    payload['InCode'] = 4;
    payload['SnNo'] = SnNo;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
      } else {
      }
     
    });
  
  }

  getList(data) {
    this.List = data.EcId;
    this.PackListForm.controls['PcklistNo3'].setValue(data.EcDesc)
    this.PackListForm.controls['PcklistNo2'].setValue(data.Oper)
  }

  getArrayControls() {
    return (this.PackListForm.get('PackingArray') as FormArray).controls;
  }
  fetchPackingList() {
    this.spinner.show();
    this.Table = false;
    this.assignTableData = []
    this.packingList = []
    this.PackingArray = this.PackListForm.get('PackingArray') as FormArray;
    this.PackingArray.clear();
    let payload = {};
    payload['EcId'] = this.List;
    payload['SubCode'] = this.PackListForm.value['SubCode'] ? this.PackListForm.value['SubCode'] : '';
    payload['HdCode'] = this.PackListForm.value['HdCode'] ? this.PackListForm.value['HdCode'] : '';
    payload['Medium'] = this.PackListForm.value['Medium'] ? this.PackListForm.value['Medium'] : '';
    payload['Bran'] = this.PackListForm.value['Bran'] ? this.PackListForm.value['Bran'] : '';
    payload['Valid'] = this.PackListForm.value['Valid'] ? this.PackListForm.value['Valid'] : '';
    payload['Chng'] = this.PackListForm.value['Chng'] ? this.PackListForm.value['Chng'] : '';
    this.umsService.fetchPackingList(payload).subscribe((res) => {
      if (res.status) {
        this.packingList = res.data;
        this.Table = true;
        this.spinner.hide();
        this.assignTableData = res.data;
        this.assignTableData.forEach((element, i) => {
          const creds = this.PackListForm.get('PackingArray') as FormArray
          creds.push(
            this.fb.group({
              PcSub: new FormControl(element['SubCode']),
              HdCode: new FormControl(element['HdCode']),
              Medium: new FormControl(element['PcMedium']),
              Cent: new FormControl(element['PcCent']),
              Count: new FormControl(element['PcCount']),
              P1: new FormControl(element['Pc1']),
              P2: new FormControl(element['Pc2']),
              P3: new FormControl(element['Pc3']),
              P4: new FormControl(element['Pc4']),
              Total: new FormControl(element['PcTotal']),
              Valid: new FormControl(element['PcValid']),
              Chng: new FormControl(element['PcChng']),
              Bran: new FormControl(element['StrCode']),
              EcId: new FormControl(element['PcEcId']),
              EsId: new FormControl(element['PcEsId'])
            })
          );
        });
      }
      else{
        this.Table = false;
        this.PackListForm.controls['EcId'].markAsTouched();
        this.spinner.hide()
        this.assignTableData = []
        this.packingList = []
      }
    });
   
  }

  updateRow(data){
    let payload = {};
    payload['EcId'] = data.value.EcId;
    payload['EsId'] = data.value.EsId;
    payload['PcSub'] = data.value.PcSub;
    payload['Medium'] = data.value.Medium;
    payload['Cent'] = data.value.Cent;
    payload['P1'] = parseInt(data.value.P1);
    payload['P2'] = parseInt(data.value.P2);
    payload['P3'] = parseInt(data.value.P3);
    payload['P4'] = parseInt(data.value.P4);
    payload['P5'] = '';
    payload['P6'] = '';
    payload['P7'] = '';
    this.umsService.updatePackingList(payload).subscribe((res) => {
      if (res.status) {
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fetchPackingList();
        })
      }
      else{
         this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      
      }
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
  });
  }

  updatePackingList() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.List;
    payload['EsId'] = this.PackListForm.value['EsId'] ? this.PackListForm.value['EsId'] : '';
    payload['PcSub'] = this.PackListForm.value['PcSub'] ? this.PackListForm.value['PcSub'] : '';
    // payload['HdCode'] = this.PackListForm.value['HdCode'] ? this.PackListForm.value['HdCode'] : '';
    payload['Medium'] = this.PackListForm.value['Medium'] ? this.PackListForm.value['Medium'] : '';
    payload['Cent'] = this.PackListForm.value['Cent'] ? this.PackListForm.value['Cent'] : '';
    payload['P1'] = this.PackListForm.value['P1'] ? this.PackListForm.value['P1'] : 0;
    payload['P2'] = this.PackListForm.value['P2'] ? this.PackListForm.value['P2'] : 0;
    payload['P3'] = this.PackListForm.value['P3'] ? this.PackListForm.value['P3'] : 0;
    payload['P4'] = this.PackListForm.value['P4'] ? this.PackListForm.value['P4'] : 0;
    payload['P5'] = this.PackListForm.value['P5'] ? this.PackListForm.value['P5'] : 0;
    payload['P6'] = this.PackListForm.value['P6'] ? this.PackListForm.value['P6'] : 0;
    payload['P7'] = this.PackListForm.value['P7'] ? this.PackListForm.value['P7'] : 0;
    this.umsService.updatePackingList(payload).subscribe((res) => {
      if (res.status) {
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fetchPackingList();
        })
      }
      else{
         this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      
      }
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
  });
  }

  updateAll(){
    this.spinner.show();
    this.PackingArray = this.PackListForm.get('PackingArray') as FormArray;
    this.Packing = this.PackingArray.value
    // let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Packing.forEach((element, index, array) => {
        let payload = {};
        payload['EcId'] = element.EcId;
        payload['EsId'] = element.EsId;
        payload['PcSub'] = element.PcSub;
        payload['Medium'] = element.Medium;
        payload['Cent'] = element.Cent;
        payload['P1'] = parseInt(element.P1);
        payload['P2'] = parseInt(element.P2);
        payload['P3'] = parseInt(element.P3);
        payload['P4'] = parseInt(element.P4);
        payload['P5'] = '';
        payload['P6'] = '';
        payload['P7'] = '';
        this.umsService.updatePackingList(payload).subscribe(res => {
        this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            // this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            // this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          // this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fetchPackingList();
        })
      } 
      // else {
      //   this.spinner.hide();
      //   let data = {}
      //   data['message'] = this.errMsg
      //   data['title'] = 'Alert'
      //   data['icon'] = 'fas fa-close'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      // }
    });
  }

  ControlLock() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.List;
    payload['LoginId'] = sessionStorage.getItem('userId');
    this.umsService.ControlLock(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
      }
      else{
        this.spinner.hide()
      }
    });
  }

  // getData(){
  //   this.Table = false
  //   this.spinner.show();
  //   const payload = this.PackListForm.value;
  //     this.umsService.SearchPackingList(payload).subscribe((res) => {
  //       if(res.status){
  //         this.spinner.hide();
  //         this.Table = true;
  //       }
  //       else{
  //         this.spinner.hide();
  //         this.Table = false;
  //       }
  //     },(ERROR: HttpErrorResponse) => {
  //       this.spinner.hide();
  //       this.Table = false;
  //     })
  // }
  Back(){
    // this.PackListForm.reset();
    this.ngOnInit();
   }

   back(){
    // this.PackListForm.reset();
    this.Table = false
  }
   goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  handleTab(event: Event) {
    const inputValue = (event.target as HTMLInputElement).value;
    // let taskListArrays = this.PackListForm.get('MarkArray') as FormArray;
    if (!/^\d*\.?\d*$/.test(inputValue)) {
      // taskListArrays.controls[i].get('GridMarks').setErrors({ NonNumericError: true });
    }
  }
}


